<script setup lang="ts">
import { QTooltip } from 'quasar'
import { ref } from 'vue'
import { Color } from '@previo/codebooks'
import PTextDescription from '../typography/system/PTextDescription.vue'
import { usePrevioDS } from '../../composables/helpers'
import { PTooltipAnchor, PTooltipArrow } from './types'

type Props = {
  text?: null | string
  arrow?: PTooltipArrow
  anchor?: PTooltipAnchor
  self?: PTooltipAnchor
  showOnMobile?: boolean
}

const ds = usePrevioDS()

const props = withDefaults(defineProps<Props>(), {
  text: null,
  anchor: PTooltipAnchor.BOTTOM_MIDDLE,
  showOnMobile: false,
})

const show = ref(false)

const hideOverlap = (): void => {
  if (!ds.screen().isMobile || !props.showOnMobile) {
    show.value = false
  }
}
</script>

<template>
  <div
    class="p-display-flex ds-tooltip-wrapper"
    @mouseover="show = true"
    @mouseleave="show = false"
    @click="hideOverlap"
  >
    <q-tooltip
      v-if="!!text || $slots.tooltip"
      v-model="show"
      :anchor="anchor"
      :self="self"
      no-parent-event
      transition-duration="0"
      :offset="[0, 6]"
      :class="{
        'arrow-start': arrow === PTooltipArrow.START,
        'arrow-top': arrow === PTooltipArrow.TOP,
        'arrow-end': arrow === PTooltipArrow.END,
        'arrow-bottom': arrow === PTooltipArrow.BOTTOM,
      }"
    >
      <slot name="tooltip">
        <p-text-description :text="text" :color="Color.WHITE" />
      </slot>
    </q-tooltip>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.ds-tooltip-wrapper {
  width: fit-content;
}
</style>
